import * as React from 'react';
export var HeadingLevel;
(function (HeadingLevel) {
    HeadingLevel[HeadingLevel["H2"] = 2] = "H2";
    HeadingLevel[HeadingLevel["h3"] = 3] = "h3";
    HeadingLevel[HeadingLevel["h4"] = 4] = "h4";
})(HeadingLevel || (HeadingLevel = {}));
export const HeadingComponent = (props) => {
    const value = props.value;
    const level = value.level >= HeadingLevel.H2 && value.level <= HeadingLevel.h4 ? value.level : HeadingLevel.h3;
    const DynamicHeadingTag = `h${level}`;
    return (React.createElement("div", { className: 'component heading-component', "data-component-type": 'heading' },
        React.createElement(DynamicHeadingTag, { className: 'heading-text', id: value.anchorId }, value.text)));
};
